import React from "react";

const Test = () => {
  const squareStyle = {
    width: "100px",
    height: "100px",
    backgroundColor: "blue",
  };

  return <div style={squareStyle}></div>;
};

export default Test;
